import { matchPath } from 'react-router-dom';

import { ROUTE_PATHS } from '../consts/routes';

export const isDsCoverRoute = (pathname: string) =>
  Boolean(matchPath({ path: ROUTE_PATHS.dsCover, end: true }, pathname));
